import { IFilterAttribute } from '@fr/vue/components/filters/common/types';
import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethodsAbstract/FilterAttributeMethodsAbstract';
import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';

export default class extends FilterAttributeMethods<IFilterAttribute, IFirstPaymentDefinition[]> {
    constructor(prepaymentData: IFirstPaymentDefinition[] | undefined) {
        const getName = (value: number) => {
            if(value === 3) return `Раннее бронирование за ${value}%`;
            return `Предоплата ${value}%`;
        }
        const adaptsDataPrepayment: IFilterAttribute[] = prepaymentData?.map((prepayment) => {
            const percentValue = Math.round(prepayment.firstPaymentPart * 100);
            return {
                id: percentValue,
                name: getName(percentValue),
                key: String(percentValue),
                keyMerged: String(percentValue),
                secondName: null,
            };
        }) || [];
        super(adaptsDataPrepayment);
        this.setFilterName('Гибкая оплата');
    }

    getCountAttribute(prepaymentsGrouped: IFirstPaymentDefinition[][]): Record<IFilterAttribute['key'], number> {
        return prepaymentsGrouped.reduce((acc, prepayments) => {
            const addedPrepayments: string[] = [];
            prepayments.forEach((prepayment) => {
                const percentValue = Math.round(prepayment.firstPaymentPart * 100);
                const prepaymentFilterAttribute = this.getAttributeById(percentValue);
                if (prepaymentFilterAttribute && !addedPrepayments.includes(prepaymentFilterAttribute.key)) {
                    acc[prepaymentFilterAttribute.key]++;
                    addedPrepayments.push(prepaymentFilterAttribute.key);
                }
            });
            return acc;
        }, this.getAttributeObjectCount() as Record<IFilterAttribute['name'], number>);
    }

    getIsOneHotelHasProperty(prepaymentsGrouped: IFirstPaymentDefinition[][]): boolean {
        return prepaymentsGrouped.some((prepayments) => prepayments.some((prepayment) => {
            return !!prepayment.firstPaymentPart;
        }));
    }
}
